import styled from 'styled-components';

const HEIGHT = 544;

export const Body = styled.div`
  width: 100%;
  min-height: ${HEIGHT}px;
  position: relative;

  .loader {
    z-index: 0;
  }

  .hs-form-frame {
    min-height: ${HEIGHT}px;
    position: relative;
    z-index: 1;
  }
`;
